import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faFileInvoice, faChartLine } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const location = useLocation();
  
  // Function to check if a path is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };
  
  return (
    <header style={{ 
      padding: '15px', 
      backgroundColor: '#4f46e5', 
      color: 'white', 
      borderBottom: '1px solid #3730a3'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center' 
      }}>
        <h1 style={{ 
          fontSize: '20px', 
          fontWeight: 'bold', 
          margin: 0 
        }}>
          HLWC Admin
        </h1>
        
        <nav>
          <ul style={{ 
            display: 'flex', 
            gap: '20px', 
            listStyle: 'none', 
            margin: 0, 
            padding: 0 
          }}>
            <li>
              <Link 
                to="/financial-report" 
                style={{ 
                  color: isActive('/financial-report') ? 'white' : 'rgba(255, 255, 255, 0.8)', 
                  textDecoration: 'none',
                  fontWeight: isActive('/financial-report') ? 'bold' : 'normal',
                  borderBottom: isActive('/financial-report') ? '2px solid white' : 'none',
                  paddingBottom: '3px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
              >
                <FontAwesomeIcon icon={faFileInvoice} />
                Rapport Financier
              </Link>
            </li>
            {/* Placeholder for future pages */}
            <li>
              <Link 
                to="#" 
                style={{ 
                  color: 'rgba(255, 255, 255, 0.8)', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px'
                }}
                onClick={(e) => e.preventDefault()}
              >
                <FontAwesomeIcon icon={faChartLine} />
                Statistiques
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
